import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VerificationsComponent } from './verifications.component';

const routes: Routes = [{ path: '', component: VerificationsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class VerificationsRoutingModule { }
